<div class="toast-wrapper">
  <div class="toast-container" [ngStyle]="{'background-color': getBackgroundColor()}" [@openCloseAnimation]="openCloseAnimationTrigger()">
    <span class="hd-icon {{getIcon()}} icon-md toast-icon" [ngStyle]="{'color': getIconColor()}"></span>
    <div sa-ellipsis class="toast-message" [placement]="'below'" [fullText]="currentToast?.message"></div>
  </div>
</div>

